<template>
  <el-dialog title="修改部门信息" :visible.sync="visible" width="500px" :before-close="closeDialog">
    <el-form v-if="department" ref="form" :model="department" :rules="rules" style="width:400px" label-width="100px">
      <el-form-item label="编号" prop="no">
        <el-input v-model="department.no" disabled></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="department.name"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="department.remark"></el-input>
      </el-form-item>
      <el-form-item align="center">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button @click="submit" type="primary">提 交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { rules } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    department: {
      type: Object,
      default(){
        return {
          no: "",
          name: "",
          remark: ""
        }
      }
    } 
  },
  data() {
    return {
      rules: {
        no:   [rules.required()],
        name: [rules.required()]
      }
    };
  },
  methods: {
    ...mapActions("department", ["update"]),
    async submit() {
      let ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }
      let res = await this.update(this.department);
      this.$message.success("修改部门成功");
      this.closeDialog();
    },
    closeDialog(){
      this.$emit('update:visible', false)
    }
  }
};
</script>

<style>
</style>

